module.exports = __webpack_public_path__ + "img/loader.930f3f1a.gif";